export default __webpack_public_path__ + "static/media/Gymnastics Hall, Ambala2.85532f5a.jpg";